import { NoDirtyDirective } from './../directives/no-dirty.directive';
import { NgInitDirective } from '../directives/ngInit.directive';
import { InteractDraggableDirective } from './../directives/interact.draggable.directive';
import { InteractResizableDirective } from '../directives/interact.resizable.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AutoFocusDirective } from '../directives/autoFocus.directive';
import { BbDragDirective } from '../directives/bb-drag.directive';
import { BbFontDirective } from '../directives/bb-font.directive';
import { BbResizeDirective } from '../directives/bb-resize.directive';
import { ClickOutsideDirective } from '../directives/clickOutside.directive';
import { EasterEggDirective } from '../directives/easterEgg.directive';
import { FileDroppableDirective } from './../directives/file-droppable.directive';
import { FocusSelectDirective } from '../directives/focus-select.directive';
import { HasPublicationFieldDirective } from '../directives/hasPublicationField.directive';
import { HasPublicationFieldAndPermissionDirective } from '../directives/hasPublicationFieldAndPermission.directive';
import { HasPublicationFieldOrPermissionDirective } from '../directives/has-publication-field-or-permission.directive';
import { ProvideParentFormDirective } from '../directives/provideParentForm.directive';
import { HasPermissionDirective } from '../directives/hasPermission.directive';
import { MaterialModule } from '../modules/material.module';


@NgModule({
	imports: [
		CommonModule,
		MaterialModule
	],
	declarations: [
		AutoFocusDirective,
		BbDragDirective,
		BbFontDirective,
		BbResizeDirective,
		ClickOutsideDirective,
		EasterEggDirective,
		FileDroppableDirective,
		FocusSelectDirective,
		HasPublicationFieldDirective,
		HasPublicationFieldAndPermissionDirective,
		HasPublicationFieldOrPermissionDirective,
		ProvideParentFormDirective,
		HasPermissionDirective,
		NoDirtyDirective,
		NgInitDirective,
		InteractDraggableDirective,
		InteractResizableDirective
	],
	exports: [
		AutoFocusDirective,
		BbDragDirective,
		BbFontDirective,
		BbResizeDirective,
		ClickOutsideDirective,
		EasterEggDirective,
		FileDroppableDirective,
		FocusSelectDirective,
		HasPublicationFieldDirective,
		HasPublicationFieldAndPermissionDirective,
		HasPublicationFieldOrPermissionDirective,
		ProvideParentFormDirective,
		HasPermissionDirective,
		MaterialModule,
		NoDirtyDirective,
		NgInitDirective,
		InteractDraggableDirective,
		InteractResizableDirective
	],
	providers: [

	]
})
export class DirectivesModule {

}
